import { Request } from "express";

// Extended Request interface to include user data
export interface AuthenticatedRequest extends Request {
  user: {
    userId: string;
    email: string;
    role: string;
    isEmailVerified: boolean;
    isProfileCompleted: boolean;
    status: string;
    iat?: number;
    exp?: number;
  };
}
